import React, { Component } from "react";
import "../../../Containers/App.css";

import HomePage from "../../HomePage/HomePage";
import Footer from "../../Footer/Footer";
import axios from "axios";
import { withRouter } from "react-router";
import {Helmet} from 'react-helmet';

import { Container, Col, Row } from "react-bootstrap";

class HomePageContainer extends Component {
  state = { products: [] };

  componentDidMount() {
    axios.get("https://api.shopmuthu.com/home").then((response) => {
      console.log(response);
      this.setState({ products: response.data });
    });
  }

  toggleProduct = () => {
    const doesShow = this.state.showProduct;
    this.setState({ showProduct: !doesShow });
  };

  showProductDisplayPage = () => {};

  render() {
    
    let product = null;

    // if(this.state.showProduct){
    //this.fetchProducts();
    const { match } = this.props;
    const category = match.params.category;
    product = (
      <Row>
        {this.state.products.map((product, index) => {
          return (
            <HomePage
              click={() => this.showProductDisplayPage(index)}
              product={product}
              key={product.productName}
            />
          );
        })}
      </Row>
    );
    //}

    return (
      <Container>
         <Helmet>
        <meta charSet="utf-8" />
        <title>ShopMuthu.com</title>
        <meta name="description" content="Check best price from  Aflipkart, Amazon , Tatacliq, Reliance digital for Mobiles, books, PS4 Games etc" />
        <meta name="keywords" content="shopmuthu.com, Mobiles, PS4 Games" />
        <link rel="canonical" href="https://shopmuthu.com" />
        <meta name="og_title" property="og:title" content="ShopMuthu.com | Shoppers Guide"/>
	      <meta name="og_url" property="og:url" content="https://shopmuthu.com"/>
	      <meta name="og_type" property="og:type" content="website"/>
		    <meta name="og_image" property="og:image" content="/shopmuthu-logo.png"/>
		    <meta name="og_site_name" property="og:site_name" content="ShopMuthu.com"/>
	      <meta name="og_description" property="og:description" content="Check best price from  Aflipkart, Amazon , Tatacliq, Reliance digital for Mobiles, books, PS4 Games etc"/>
	      <meta name="twitter:card" content = "summary"/>
	      <meta name="twitter:site" content="@shopmuthu"/>
	      <meta name="twitter:creator" content="@shopmuthu"/>
	      <meta name="twitter:title" content="ShopMuthu.com | Shoppers Guide"/>
	      <meta name="twitter:description" content="Check best price from  Aflipkart, Amazon , Tatacliq, Reliance digital for Mobiles, books, PS4 Games etc"/>
		    <meta name="twitter:image" content="/shopmuthu-logo.png"/>
      
      </Helmet>
        <Row>
          <Col className="col-md-12">
            <nav>
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <a href="/">Home</a>
                </li>

                <li className="breadcrumb-item active">{category}</li>
              </ol>
            </nav>
          </Col>
        </Row>

        {product}

        <Footer />
      </Container>
    );
  }
}

export default withRouter(HomePageContainer);
